module.exports = __webpack_public_path__ + "img/pool_white_icon.36fea218.svg";